// extracted by mini-css-extract-plugin
export var columnList = "_9n-0";